import { useTranslation } from 'react-i18next'
import {
  useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId,
} from '@/api/generated/company-management-user/company-management-user'
import type { ServiceModuleModel, TextServiceModuleModel } from '@/api/model'
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/shadcn/dialog'
import { Button } from '@/components/shadcn/button'
import { LoaderGeneral } from '@/components/common/loaders/LoaderGeneral'
import { RichTextEditor } from '@/components/common/RichTextEditor.tsx';

interface Props {
  module: ServiceModuleModel
  onClose: () => void
}

/**
 * Open dialog of a Text module: display only of the content (`text`).
 * Editing happens exclusively via the pencil → `EditTextServiceModule`.
 */
export function TextServiceModuleDialog({ module, onClose }: Props) {
  const { t } = useTranslation(['service-modules-text', 'service-modules', 'common'])
  const { data, isLoading, isError } = useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId(module.id)
  const detail = ((data as any)?.data ?? data) as TextServiceModuleModel | undefined

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <div
              className="size-7 rounded"
              style={{ backgroundColor: module.colorHex || '#64748b' }}
            />
            {module.name}
          </DialogTitle>
          <DialogDescription>{t('openText.description')}</DialogDescription>
        </DialogHeader>

        <LoaderGeneral
          isLoading={isLoading}
          isError={isError}
          isEmpty={!detail?.text}
          loadingMessage={t('openText.loading')}
          errorMessage={t('openText.loadError')}
          emptyMessage={t('openText.empty')}
        >
          <RichTextEditor
            value={detail?.text ?? ''}
            onChange={() => {}}
            disabled
            hideToolbar
            className="max-h-96 overflow-y-auto"
          />
        </LoaderGeneral>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t('buttons.close', { ns: 'common' })}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
